import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

export default function FichajeDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [fichaje, setFichaje] = useState(null);
  const [empleados, setEmpleados] = useState([]);
  const [log, setLog] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [modalEditar, setModalEditar] = useState(false);
  const [modalAnular, setModalAnular] = useState(false);
  const [form, setForm] = useState({});
  const [motivoEdicion, setMotivoEdicion] = useState('');
  const [motivoAnular, setMotivoAnular] = useState('');
  const [error, setError] = useState('');

  useEffect(() => { cargar(); }, [id]);

  const cargar = async () => {
    try {
      const [fRes, eRes, lRes] = await Promise.all([
        API.get('/fichajes'),
        API.get('/empleados'),
        API.get(`/fichajes/${id}/log`),
      ]);
      const f = fRes.data.find(x => x.id === parseInt(id));
      setFichaje(f || null);
      setEmpleados(eRes.data);
      setLog(lRes.data || []);
    } catch(e) {}
    setCargando(false);
  };

  const guardarEditar = async () => {
    if (!motivoEdicion.trim()) { setError('El motivo es obligatorio'); return; }
    try {
      const entrada = `${form.fecha}T${form.hora_entrada}:00`;
      const salida = form.hora_salida ? `${form.fecha}T${form.hora_salida}:00` : null;
      await API.put(`/fichajes/${id}`, { entrada, salida, notas: form.notas || null, motivo_modificacion: motivoEdicion });
      setModalEditar(false);
      cargar();
    } catch(e) { setError('Error al guardar'); }
  };

  const anular = async () => {
    if (!motivoAnular.trim()) { setError('El motivo es obligatorio'); return; }
    try {
      await API.put(`/fichajes/${id}`, { anulado: true, motivo_modificacion: motivoAnular });
      setModalAnular(false);
      cargar();
    } catch(e) { setError('Error al anular'); }
  };

  const fmtDatetime = (iso) => iso ? new Date(iso).toLocaleString('es-ES', {day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'}) : '—';
  const fmtHora = (iso) => iso ? new Date(iso).toLocaleTimeString('es-ES', {hour:'2-digit',minute:'2-digit'}) : '—';
  const duracion = (entrada, salida) => {
    if (!salida) return '—';
    const mins = Math.round((new Date(salida) - new Date(entrada)) / 60000);
    return `${Math.floor(mins/60)}h${mins%60>0?' '+mins%60+'m':''}`;
  };
  const nombreEmpleado = (empId) => empleados.find(e => e.id === empId)?.nombre || '—';

  if (cargando) return <div style={s.loading}>Cargando...</div>;
  if (!fichaje) return <div style={s.loading}>Fichaje no encontrado</div>;

  const entrada = new Date(fichaje.entrada);

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <button style={s.backBtn} onClick={() => navigate('/fichajes')}>← Fichajes</button>
      </div>

      <div style={s.content}>
        {/* CABECERA */}
        <div style={s.header}>
          <div style={s.headerLeft}>
            <div style={s.headerInfo}>
              <div style={s.headerNombre}>{nombreEmpleado(fichaje.empleado_id)}</div>
              <div style={s.headerFecha}>{entrada.toLocaleDateString('es-ES', {weekday:'long', day:'numeric', month:'long', year:'numeric'})}</div>
              <div style={s.pills}>
                {fichaje.anulado
                  ? <span style={s.pillAnulado}>Anulado</span>
                  : fichaje.salida
                    ? <span style={s.pillOk}>Completado</span>
                    : <span style={s.pillActivo}>En curso</span>
                }
              </div>
            </div>
          </div>
          {usuario?.rol === 'admin' && !fichaje.anulado && (
            <div style={s.headerActions}>
              <button style={s.btnSecondary} onClick={() => {
                setForm({
                  fecha: entrada.toISOString().split('T')[0],
                  hora_entrada: fmtHora(fichaje.entrada),
                  hora_salida: fichaje.salida ? fmtHora(fichaje.salida) : '',
                  notas: fichaje.notas || '',
                });
                setMotivoEdicion('');
                setError('');
                setModalEditar(true);
              }}>Editar</button>
              <button style={s.btnDanger} onClick={() => { setMotivoAnular(''); setError(''); setModalAnular(true); }}>Anular</button>
            </div>
          )}
        </div>

        {/* DATOS */}
        <div style={s.grid2}>
          <div style={s.card}>
            <div style={s.cardTitle}>Registro horario</div>
            <div style={s.infoRow}><span style={s.infoLabel}>Entrada</span><span style={s.infoValor}>{fmtDatetime(fichaje.entrada)}</span></div>
            <div style={s.infoRow}><span style={s.infoLabel}>Salida</span><span style={s.infoValor}>{fichaje.salida ? fmtDatetime(fichaje.salida) : '— (en curso)'}</span></div>
            <div style={s.infoRow}><span style={s.infoLabel}>Duración</span><span style={{...s.infoValor, fontWeight:600, color:'#378ADD'}}>{duracion(fichaje.entrada, fichaje.salida)}</span></div>
            {fichaje.notas && <div style={s.infoRow}><span style={s.infoLabel}>Notas</span><span style={s.infoValor}>{fichaje.notas}</span></div>}
          </div>
          <div style={s.card}>
            <div style={s.cardTitle}>Trazabilidad</div>
            <div style={s.infoRow}><span style={s.infoLabel}>Registrado por</span><span style={s.infoValor}>{fichaje.usuario_id === fichaje.empleado_id ? nombreEmpleado(fichaje.empleado_id) : 'Admin'}</span></div>
            {fichaje.motivo_modificacion && <div style={s.infoRow}><span style={s.infoLabel}>Último motivo</span><span style={{...s.infoValor, color:'#e8a838'}}>{fichaje.motivo_modificacion}</span></div>}
            {fichaje.fecha_modificacion && <div style={s.infoRow}><span style={s.infoLabel}>Modificado el</span><span style={s.infoValor}>{fmtDatetime(fichaje.fecha_modificacion)}</span></div>}
            {fichaje.anulado && <div style={s.infoRow}><span style={s.infoLabel}>Estado</span><span style={{...s.infoValor, color:'#A32D2D', fontWeight:600}}>ANULADO</span></div>}
          </div>
        </div>

        {/* LOG */}
        <div style={s.card}>
          <div style={s.cardTitle}>Historial de cambios</div>
          {log.length === 0 ? (
            <div style={s.emptySmall}>Sin cambios registrados</div>
          ) : (
            log.map((entry, i) => (
              <div key={i} style={s.logRow}>
                <span style={s.logFecha}>{new Date(entry.fecha).toLocaleString('es-ES', {day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'})}</span>
                <span style={s.logUsuario}>{entry.usuario}</span>
                <span style={s.logAccion}>{entry.texto}</span>
              </div>
            ))
          )}
        </div>
      </div>

      {/* MODAL EDITAR */}
      {modalEditar && (
        <div style={s.overlay} onClick={() => setModalEditar(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}><div style={s.modalTitle}>Editar fichaje</div><button style={s.closeBtn} onClick={() => setModalEditar(false)}>✕</button></div>
            {error && <div style={s.errorBox}>{error}</div>}
            <div style={s.field}><label style={s.label}>Fecha</label><input style={s.input} type="date" value={form.fecha} onChange={e => setForm({...form, fecha: e.target.value})} /></div>
            <div style={s.fieldRow}>
              <div style={{...s.field, flex:1}}><label style={s.label}>Hora entrada</label><input style={s.input} type="time" value={form.hora_entrada} onChange={e => setForm({...form, hora_entrada: e.target.value})} /></div>
              <div style={{...s.field, flex:1}}><label style={s.label}>Hora salida</label><input style={s.input} type="time" value={form.hora_salida} onChange={e => setForm({...form, hora_salida: e.target.value})} /></div>
            </div>
            <div style={s.field}><label style={s.label}>Notas</label><input style={s.input} value={form.notas} onChange={e => setForm({...form, notas: e.target.value})} /></div>
            <div style={s.field}><label style={s.label}>Motivo de la modificación *</label><input style={s.input} value={motivoEdicion} onChange={e => setMotivoEdicion(e.target.value)} placeholder="Obligatorio por ley (RDL 8/2019)" /></div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModalEditar(false)}>Cancelar</button>
              <button style={s.btn} onClick={guardarEditar}>Guardar cambios</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL ANULAR */}
      {modalAnular && (
        <div style={s.overlay} onClick={() => setModalAnular(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}><div style={s.modalTitle}>Anular fichaje</div><button style={s.closeBtn} onClick={() => setModalAnular(false)}>✕</button></div>
            <p style={{fontSize:13,color:'#666',marginBottom:16}}>El fichaje quedará anulado pero visible. Esta acción queda registrada.</p>
            {error && <div style={s.errorBox}>{error}</div>}
            <div style={s.field}><label style={s.label}>Motivo *</label><input style={s.input} value={motivoAnular} onChange={e => setMotivoAnular(e.target.value)} placeholder="Ej: Error de fichaje, duplicado..." /></div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModalAnular(false)}>Cancelar</button>
              <button style={{...s.btn, background:'#A32D2D'}} onClick={anular}>Confirmar anulación</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  page: { display:'flex', flexDirection:'column', minHeight:'100vh', background:'#f5f5f3', fontFamily:'-apple-system, BlinkMacSystemFont, Inter, sans-serif' },
  loading: { display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#aaa', fontSize:14 },
  topbar: { background:'white', borderBottom:'0.5px solid #e0e0d8', padding:'0 24px', height:48, display:'flex', alignItems:'center' },
  backBtn: { background:'none', border:'none', fontSize:13, color:'#378ADD', cursor:'pointer', fontWeight:500 },
  content: { padding:24, display:'flex', flexDirection:'column', gap:16 },
  header: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:12, padding:24, display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:16 },
  headerLeft: { display:'flex', alignItems:'center', gap:16 },
  headerInfo: {},
  headerNombre: { fontSize:18, fontWeight:600, color:'#1a1a1a', marginBottom:2 },
  headerFecha: { fontSize:13, color:'#888', marginBottom:8 },
  pills: { display:'flex', gap:6 },
  headerActions: { display:'flex', gap:8 },
  grid2: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 },
  card: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:12, padding:20 },
  cardTitle: { fontSize:13, fontWeight:600, color:'#1a1a1a', marginBottom:16 },
  infoRow: { display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'0.5px solid #f0f0ed', fontSize:13 },
  infoLabel: { color:'#888' },
  infoValor: { color:'#1a1a1a' },
  logRow: { display:'flex', alignItems:'baseline', gap:12, padding:'10px 0', borderBottom:'0.5px solid #f0f0ed', fontSize:12 },
  logFecha: { color:'#aaa', flexShrink:0, fontFamily:'monospace', fontSize:11 },
  logUsuario: { color:'#378ADD', flexShrink:0, fontWeight:500 },
  logAccion: { color:'#666' },
  emptySmall: { fontSize:13, color:'#aaa', padding:'16px 0', textAlign:'center' },
  pillOk: { background:'#EAF3DE', color:'#3B6D11', fontSize:11, padding:'2px 8px', borderRadius:10, fontWeight:500 },
  pillActivo: { background:'#E6F1FB', color:'#185FA5', fontSize:11, padding:'2px 8px', borderRadius:10, fontWeight:500 },
  pillAnulado: { background:'#FCEBEB', color:'#A32D2D', fontSize:11, padding:'2px 8px', borderRadius:10 },
  btn: { background:'#378ADD', color:'white', border:'none', borderRadius:8, padding:'8px 14px', fontSize:13, fontWeight:500, cursor:'pointer' },
  btnSecondary: { background:'white', color:'#666', border:'0.5px solid #d0d0c8', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
  btnDanger: { background:'#FCEBEB', color:'#A32D2D', border:'none', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
  errorBox: { background:'#FCEBEB', color:'#A32D2D', borderRadius:8, padding:'10px 14px', fontSize:13, marginBottom:16 },
  field: { marginBottom:16 },
  fieldRow: { display:'flex', gap:12 },
  label: { display:'block', fontSize:13, color:'#444', marginBottom:6, fontWeight:500 },
  input: { width:'100%', padding:'9px 12px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:14, outline:'none', boxSizing:'border-box', background:'white' },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.3)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
  modal: { background:'white', borderRadius:12, border:'0.5px solid #e0e0d8', padding:24, width:'100%', maxWidth:440, maxHeight:'90vh', overflowY:'auto' },
  modalHeader: { display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 },
  modalTitle: { fontSize:15, fontWeight:500, color:'#1a1a1a' },
  closeBtn: { background:'none', border:'none', fontSize:16, cursor:'pointer', color:'#aaa' },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, marginTop:24 },
};
